import React from "react";
import styles from "./style.module.css"; // Ensure you're using CSS Modules
import PrintScreenshot from "../../images/Print.webp"; // Replace with your screenshot

const Print = () => {
  return (
    <div className={styles.destinationArea}>
      <div className={styles.container}>
        <h1 className={styles.wpoSectionTitle}>Print</h1>
        <div className={styles.destinationItem}>
          <div className={styles.destinationImg}>
            <img
              src={PrintScreenshot}
              alt="Print Process"
              className={styles.screenshot}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Print;